module.exports = __webpack_public_path__ + "img/28a)Ritz Carlton Hotel.jpg";